<template></template>
<script>
export default {
	name: 'CloMapGoogleMarker',
	props: {
		google: {
			type: Object,
			required: true,
		},
		map: {
			type: Object,
			required: true,
		},
		marker: {
			type: Object,
			required: true,
		},
		content: {
			type: String,
			default: null,
		},
		infoWindowZIndex: {
			type: Number,
			default: 1,
		},
	},
	data() {
		return {
			markerInstance: null,
			infoWindow: null,
			generic:
				'<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"> <g fill-rule="evenodd"> <path fill="#FFF" d="M5.26969384,11.41227 L5.22772618,11.2378341 C5.07636739,10.617133 5,9.99643199 5,9.39535498 C5,5.31791602 8.14000688,2 11.999656,2 C15.8599931,2 19,5.31791602 19,9.39535498 C19,9.99643199 18.9236326,10.617133 18.7715858,11.2392877 L18.7282422,11.4217186 C18.3574131,12.7881331 12.9742002,22.2202888 12.3859649,23.2916159 L12,23.9973545 L11.5906433,23.3068791 C10.9638803,22.2479079 5.67354661,12.9218673 5.26969384,11.41227 Z"/> <path fill="#228000" d="M11.648828,21.4036803 C11.1116025,20.4891143 6.57732567,12.4325217 6.23116615,11.1287786 L6.19519387,10.9781294 C6.06545776,10.4420694 6,9.90600945 6,9.38689749 C6,5.86547293 8.69143447,3 11.9997051,3 C15.3085655,3 18,5.86547293 18,9.38689749 C18,9.90600945 17.9345422,10.4420694 17.8042164,10.9793848 L17.7670647,11.1369388 C17.4492113,12.317024 12.8347339,20.4652615 12.3305322,21.3904985 L11.9997051,22 L11.648828,21.4036803 Z M12,11 C13.1045695,11 14,10.1045695 14,9 C14,7.8954305 13.1045695,7 12,7 C10.8954305,7 10,7.8954305 10,9 C10,10.1045695 10.8954305,11 12,11 Z"/> </g></svg>',
			personal:
				'<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill-rule="evenodd"> <path fill="#FFF" d="M5.26969384,11.41227 L5.22772618,11.2378341 C5.07636739,10.617133 5,9.99643199 5,9.39535498 C5,5.31791602 8.14000688,2 11.999656,2 C15.8599931,2 19,5.31791602 19,9.39535498 C19,9.99643199 18.9236326,10.617133 18.7715858,11.2392877 L18.7282422,11.4217186 C18.3574131,12.7881331 12.9742002,22.2229344 12.3859649,23.2942615 L12,24 L11.5906433,23.3095246 C10.9638803,22.2505534 5.67354661,12.9218673 5.26969384,11.41227 Z"/> <path fill="#007bc2" d="M11.648828,21.4036803 C11.1116025,20.4891143 6.57732567,12.4325217 6.23116615,11.1287786 L6.19519387,10.9781294 C6.06545776,10.4420694 6,9.90600945 6,9.38689749 C6,5.86547293 8.69143447,3 11.9997051,3 C15.3085655,3 18,5.86547293 18,9.38689749 C18,9.90600945 17.9345422,10.4420694 17.8042164,10.9793848 L17.7670647,11.1369388 C17.4492113,12.317024 12.8347339,20.4652615 12.3305322,21.3904985 L11.9997051,22 L11.648828,21.4036803 Z"/> </g></svg>',
			hotspot:
				'<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="#FFF" d="M5.26969384,11.41227 L5.22772618,11.2378341 C5.07636739,10.617133 5,9.99643199 5,9.39535498 C5,5.31791602 8.14000688,2 11.999656,2 C15.8599931,2 19,5.31791602 19,9.39535498 C19,9.99643199 18.9236326,10.617133 18.7715858,11.2392877 L18.7282422,11.4217186 C18.3574131,12.7881331 12.9742002,22.2229344 12.3859649,23.2942615 L12,24 L11.5906433,23.3095246 C10.9638803,22.2505534 5.67354661,12.9218673 5.26969384,11.41227 Z"/><path fill="#cc3340" d="M11.6491228,21.4036803 C11.1118974,20.4891143 6.57732567,12.4325217 6.23116615,11.1287786 L6.19519387,10.9781294 C6.06545776,10.4420694 6,9.90600945 6,9.38689749 C6,5.86547293 8.69143447,3 11.9997051,3 C15.3085655,3 18,5.86547293 18,9.38689749 C18,9.90600945 17.9345422,10.4420694 17.8042164,10.9793848 L17.7670647,11.1369388 C17.4492113,12.317024 12.8350287,20.4652615 12.3308271,21.3904985 L12,22 L11.6491228,21.4036803 Z M13.7487061,9.57553885 C12.7614377,8.20699757 12.0234269,6.97825001 12.486148,5.84226276 C13.0204574,4.53251322 9.89790383,8.65446811 9.48724703,10.9826214 C9.480739,11.0067913 8.93146113,13.5505144 11.3283692,14.2142079 C10.4107367,12.5079407 11.9596482,10.9721695 11.9596482,10.9721695 C13.0471403,12.3688002 12.8857411,13.5100134 12.5564347,14.2272727 C13.4896865,14.0103965 14.2699995,13.2885645 14.5003838,12.2884515 C14.7203552,11.3340654 14.4183826,10.5135939 13.7487061,9.57553885 Z"/></g></svg>',
		};
	},
	computed: {
		svg() {
			switch (this.marker.type) {
				case 'hotspot':
					return this.hotspot;
					break;
				case 'personal':
					return this.personal;
					break;
				default:
					return this.generic;
			}
		},
		size() {
			return this.marker.size === 'sm' ? 24 : 32;
		},
	},
	watch: {
		content: function () {
			if (this.marker.content) {
				this.showInfoWindow();
			}
		},
	},
	mounted() {
		const icon = {
			url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(this.svg),
			//fillColor: '#FF0000',
			//fillOpacity: 0.6,
			anchor: new this.google.maps.Point(this.size / 2, this.size),
			scaledSize: new this.google.maps.Size(this.size, this.size),
		};
		this.markerInstance = new this.google.maps.Marker({
			position: this.marker.position,
			marker: this.marker,
			map: this.map,
			icon: icon,
		});
		this.markerInstance.addListener('click', () => {
			if (this.content) {
				this.showInfoWindow();
			}
			this.$emit('marker-click', this.marker);
		});
	},
	beforeDestroy() {
		this.google.maps.event.clearListeners(this.markerInstance, 'click');
		if (this.infoWindow) {
			this.infoWindow.setMap(null);
		}
		this.markerInstance.setMap(null);
	},
	methods: {
		showInfoWindow() {
			if (this.infoWindow) {
				this.infoWindow.setZIndex(this.infoWindowZIndex);
				this.infoWindow.setContent(this.content);
			} else {
				this.infoWindow = new this.google.maps.InfoWindow({
					content: this.marker.content,
					zIndex: this.infoWindowZIndex,
				});
			}
			this.infoWindow.open(this.map, this.markerInstance);
		},
	},
};
</script>

<style></style>
